// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2IX_1","title":"AfterBackImages_title__BiZIC","images":"AfterBackImages_images__3NUOZ"};